import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchCustomerJourney, deleteCustomerJourney, fetchIndustries } from '../services/userCustomerJourney';
import { toast } from 'react-toastify';

export const useFetchCustomerJourney = (industriesType, filteredData) => {
    return useQuery({
        queryKey: ['customerJourney', { industriesType, filteredData }], // Unique query key
        queryFn: fetchCustomerJourney, // Pass a function reference
        cacheTime: 5 * 60 * 1000, // Cache data for 5 minutes
        staleTime: 0, // Data becomes stale immediately for refetching if required
    });
};
export const useFetchIndustries = () => {
    return useQuery({
        queryFn: fetchIndustries, // Pass a function reference
        cacheTime: 5 * 60 * 1000, // Cache data for 5 minutes
        staleTime: 0, // Data becomes stale immediately for refetching if required
    });
};
// Hook to delete an organization
export const useDeleteCustomerJourney = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteCustomerJourney,
        onSuccess: (response) => {
            if (response.status === 200 || response.status === 201) {
                toast.success(response?.data?.message || 'Customer Journey deleted successfully.');
                queryClient.invalidateQueries(['customerJourney']); // Refetch organizations on successful deletion
            }
        },
        onError: () => {
            toast.error('Error deleting customer Journey.');
        },
    });
};
